module.exports = __webpack_public_path__ + "static/media/Writing-Working.c9252230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Writing-Working/Writing-Working.jpg
// module id = 761
// module chunks = 0